export var showDeprecatedAlgebraLabWarning = function() {
  $('#calc-eval-deprecated').show();
  $('#warning-icon').show();
  $('#dismiss-icon').show();
  $('#warning-banner').show();
};
